var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":"人员列表","bordered":false}},[_c('custom-table',{attrs:{"row-key":"id","loading":_vm.loading,"data-source":_vm.dataList,"columns":_vm.tableColumns,"pagination":_vm.pagination,"scroll":_vm.scrollConfig},on:{"change":_vm.handleTableChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }